/**
 * @generated SignedSource<<33ae423baf124a2e48b404fcbcd3a540>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorRoleAuthor$data = {
  readonly role: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "authorRoleAuthor";
};
export type authorRoleAuthor$key = {
  readonly " $data"?: authorRoleAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorRoleAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorRoleAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "ac4036f63ec81fa94793e91bf08ba599";

export default node;
